import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxCollection,
  RxDocument,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const packFooterSchemaLiteral = {
  title: 'Pack Footer Schema',
  description: 'Describes a pack footer',
  version: 0,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    name: {
      type: 'string',
    },
    image: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'image'],
  indexes: [],
} as const

const schemaTyped = toTypedRxJsonSchema(packFooterSchemaLiteral)

export type PackFooterDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const packFooterSchema: RxJsonSchema<PackFooterDocType> = schemaTyped

export type PackFooterDocMethods = {
  test: () => void
}

export const packFooterDocMethods = {
  test: () => null,
}

export type PackFooterDocument = RxDocument<PackFooterDocType, PackFooterDocMethods>

export type PackFooterCollectionMethods = {
  test: () => void
}

export type PackFooterCollection = RxCollection<PackFooterDocType, PackFooterDocMethods, PackFooterCollectionMethods>
